import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CertificationTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CertificationTypeCreateDto,
  CertificationTypeDto,
  CertificationTypeExcelDownloadDto,
  CertificationTypeUpdateDto,
} from '../proxy/planning/dtos/certification-type';
import { CERTIFICATIONTYPE_CONFIG, CERTIFICATIONTYPE_FIELDS } from './certification-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-certification-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CertificationTypeService, ConfirmationService],
  templateUrl: './certification-type.html',
  styleUrl: './certification-type.scss',
})
export class CertificationType extends BaseCrudComponent<
  CertificationTypeDto,
  CertificationTypeCreateDto,
  CertificationTypeUpdateDto,
  CertificationTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(CertificationTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('CertificationType', ids),
  };
  config = CERTIFICATIONTYPE_CONFIG;
  fields = CERTIFICATIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CertificationTypeDto): CertificationTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CertificationType';
  }
}
